import { Banner, Layout, Page } from '@shopify/polaris'
import React from 'react'

import { showIntercom } from './helpers'

export const LoadErrorBanner = () => {
  return (
    <Banner
      tone="critical"
      action={{
        content: 'Contact support',
        onAction: () => showIntercom('I am having trouble loading the app.'),
      }}
    >
      <p>This page could not be loaded. Please try again later.</p>
    </Banner>
  )
}

export const LoadErrorPage = () => (
  <Page>
    <Layout>
      <Layout.Section>
        <LoadErrorBanner />
      </Layout.Section>
    </Layout>
  </Page>
)
